import '@/components/login';

export default {
    name: 'login',
    // Initial props provided by the main.js initialization.
    props: [
        'locale',
        'token',
        'appId',
        'isMobile',
        'systemMessage',
        'systemMessageTransition',
        'apps',
        'languages'
    ],
    // Initial data for component.
    data() {
        return {
            view: this.getParameterByName('view') || 'login-form',
            transition: 'component-slide-fade-up',
            user: null,
            alert: null,
            sentVia: null,
            code: null,
            currentSystemMessage: this.systemMessage,
            currentSystemMessageTransition: this.systemMessageTransition,
            termsOfService: null,
            redirect: ''
        };
    },
    // Execute this when the component is created but not yet rendered.
    created() {
        // If they refresh within the forgot password process, redirect to first step.
        if (this.view === 'get-code' || this.view === 'reset-password') {
            this.view = 'forgot-password';
        }

        // Handle enter-code separately since the user can get there
        // by clicking through from an email.
        if (this.view === 'enter-code') {
            // We set the username and code in the email url.
            // Get those params from the url.
            let code = this.getParameterByName('code');
            let username = this.getParameterByName('quoreid');

            // If the params don't exist, redirect to forgot password.
            if (!code || !username) {
                this.view = 'forgot-password';

                // If the params DO exist, set them accordingly.
            } else {
                this.user = {
                    username: this.getParameterByName('quoreid')
                };
                this.sentVia = 'email';
                this.code = this.getParameterByName('code');
            }
        }

        this.redirect = this.getParameterByName('redirect_to');

        // Handle the back and forward buttons to set the view from the history.
        window.onpopstate = () => {
            // Get view param value from url.
            let view = this.getParameterByName('view');

            if (!view) {
                view = 'login-form';
            }

            // Set view data object within component to view from url.
            this.view = view;
        };
    },
    mounted() {
        // NOTE: This functionality will likely need to be across ALL page components.
        //     - It will temporarily live here in Login.

        // Function for settings cookies.
        window.setCookie = (cname, cvalue, exdays) => {
            var d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            var expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
            document.cookie =
                cname +
                '=' +
                cvalue +
                ';' +
                expires +
                ";domain='.$domain.';path=/";
        };

        // Current URL path that we can check against localization exceptions.
        let currentPath = window.location.pathname;

        let languageTranslated = this.languages.hasOwnProperty('translated')
            ? 'translated'
            : 'isTranslated';

        // If the locale isn't english we need to check if it's localized or not.
        if (this.locale !== 'en') {
            // If localized.
            if (
                this.apps[this.appId] && // App data exists.
                this.languages[this.locale] && // Language data exists.
                this.apps[this.appId].translated && // App is translated.
                this.languages[this.locale][languageTranslated] && // Language is translated.
                (!this.apps[this.appId].exceptions.length || // App has 0 exceptions.
                    !this.apps[this.appId].exceptions.includes(currentPath)) // App doesn't have current URL as an exception.
            ) {
                // Delete the googtrans cookie.
                document.cookie =
                    'googtrans= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';

                // If Google Translate is needed.
            } else {
                let googleTranslateScript = document.createElement('script');
                let translationLocale = this.locale;

                // Url for google translate -- this will need to change for China. (.com/.cn)
                googleTranslateScript.src =
                    '//translate.google.com/translate_a/element.js?cb=initGoogleTranslate';

                // Set the googtrans cookie to the appropriate locale.
                window.setCookie('googtrans', `/en/${translationLocale}`);

                // Set the event to fire after google translate loads.
                window.initGoogleTranslate = () => {
                    new window.google.translate.TranslateElement({
                        pageLanguage: 'en',
                        layout:
                            window.google.translate.TranslateElement
                                .InlineLayout.HORIZONTAL,
                        autoDisplay: false
                    });
                };

                // Append the script to the body.
                document.body.appendChild(googleTranslateScript);
            }
        } else {
            // Delete the googtrans cookie.
            document.cookie =
                'googtrans= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
        }
    },
    // Watch events for this main component.
    watch: {
        // Watch view change to set update the history queue with new view.
        // This will allow for back and forward buttons to work.
        view(componentName) {
            if (history.pushState) {
                // Create path with component view param.
                var protocol = window.location.protocol,
                    host = window.location.host,
                    path = window.location.pathname,
                    url = `${protocol}//${host}${path}?view=${componentName}`;

                // Push path to the browser history.
                window.history.pushState({ path: url }, '', url);
            }
        }
    },
    // Methods used within this component.
    methods: {
        // Get a specific url parameter by the name of that parameter.
        // This is used for getting the view that should show based on url.
        getParameterByName(name, url) {
            // Set url to the window url if the variable is null from the passed param.
            if (!url) {
                url = window.location.href;
            }

            // Prep the passed in name for regex.
            name = name.replace(/[[\]]/g, '\\$&');

            // Use regular expressions to get the param and it's value.
            var regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`),
                results = regex.exec(url);

            // If no results, return null.
            if (!results) {
                return null;
            }

            // If the value is empty, return empty string.
            if (!results[2]) {
                return '';
            }

            // Else return the value that was grabbed from the url.
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    }
};
